module.exports = __webpack_public_path__ + "static/media/orangeCloseIcon.7b8c2fe8.svg";